import PropTypes from 'prop-types';
import React from 'react';

const MessageSent = (props) => {
  /**
   * Dados padrões para definir uma mensagens a ser editada
   * @param {*} messageSelected
   */

  return (
    <div className="message-line">
      <div
        className="message-sent messageAnimation"
        data-testid="message-sent-test"
        id={`msg-${props.message.id}`}
        data-aut-test={`msg-${
          props.message.edit ? props.message.edit : props.message.id
        }-answered-content`}
      >
        <div className="message-div">{props.children}</div>
      </div>
    </div>
  );
};

MessageSent.propTypes = {
  children: PropTypes.string,
  message: PropTypes.object
};

export default MessageSent;
